// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__2XTrz","footer":"ModalFilter_footer__m0Rfs"};